export enum FormGroupStatus {
  All = 1,
  Draft = 2,
  InReview = 3,
  ChangesRequired = 4,
  Approved = 5,
  Published = 6,
  Archived = 7,
}

export enum WizardStepEnum {
  Metadata = 1,
  QuestionnaireyAndDocuments = 2,
  ReviewAndPublish = 3,
}

export const FORM_GROUP_STATUS = {
  Draft: "Draft",
  InReview: "In Review",
  ChangesRequired: "Changes Required",
  Approved: "Approved",
  Published: "Published",
  Archived: "Archived",
  Unknown: "Unknown",
};
